import styled from 'styled-components';

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 100px 0;

  h1 {
    font-family: ${({ theme }) => theme.core.fontFamily.semiBold};
  }

  a {
    font-size: ${({ theme }) => theme.core.fontSizes.l}px;

    text-decoration: none;
    color: ${({ theme }) => theme.core.colors.primary.green.medium};
  }

  img {
    width: 80%;
  }

  @media ${({ theme }) => `${theme.breakpoints.m}`} {
    img {
      width: 400px;
    }
  }
`;
